'use client';

import { CommunityGuidelinesContent } from '@wt/app/community/guidelines/_components/CommunityGuidelinesContent';
import useKeypress from '@wt/shared/hooks/useKeyPress';
import { useEffect, useRef } from 'react';

const GuidelinesModal = ({
  firstTimeViewing,
  closeModal,
}: {
  firstTimeViewing: boolean;
  closeModal: () => void;
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useKeypress('Escape', () => {
    if (!firstTimeViewing) {
      closeModal();
    }
  });

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (!firstTimeViewing) {
        if (
          modalRef.current &&
          !event.composedPath().includes(modalRef.current)
        ) {
          closeModal();
        }
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [modalRef]);

  return (
    <div className="modal pointer-events-auto visible flex items-center justify-center opacity-100">
      <div
        ref={modalRef}
        className="modal-box visible fixed z-50 w-full max-w-4xl bg-base-200 p-0"
      >
        <div className="relative flex flex-col">
          <CommunityGuidelinesContent
            closeModal={closeModal}
            showButtons={!firstTimeViewing}
          />
          {firstTimeViewing && (
            <div className="sticky bottom-0 z-20 flex w-full items-center justify-center bg-base-200 p-4">
              <AgreeButton closeModal={closeModal} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GuidelinesModal;

const AgreeButton = ({ closeModal }: { closeModal: () => void }) => {
  return (
    <button
      className="btn h-[40px] min-h-[40px] w-fit shrink border border-gray-400 bg-base-300 text-base font-bold text-base-100 hover:bg-base-300/80"
      onClick={closeModal}
    >
      Agree
    </button>
  );
};
